import styled from 'styled-components';

import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

import { breakPoints } from '~/src/constants/breakpoints';
import { BACKGROUND_COLOR_BLACK } from '~/src/features/movix-new/constants';

import { Container } from '~/src/features/movix-new/styled';

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
  background: ${BACKGROUND_COLOR_BLACK};
  z-index: 1;
  margin-top: -1px;

  @media (max-width: ${breakPoints.mobile}) {
    :before {
      content: '';
      position: absolute;
      top: -46%;
      left: -207%;
      width: 1595px;
      height: 2100px;

      background: radial-gradient(33.01% 38.15% at 50.05% 46.07%, rgba(1, 128, 135, 0.65) 0%, rgba(2, 52, 55, 0) 100%);
      mix-blend-mode: normal;
      opacity: 0.5;
    }
  }
`;

export const Background = styled.div`
  width: 100%;
  height: 1172px;
  position: absolute;
  left: 0;
  overflow: hidden;
`;

export const CardsWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr auto;
  grid-template-areas: 'first second'
  'large large';
  row-gap: 24px;
  column-gap: 26px;
  width: 100%;

  @media (max-width: ${breakPoints.mobile}) {
    grid-template-rows: min-content min-content min-content;
    grid-auto-rows: min-content;
    grid-template-columns: 100%;
    grid-template-areas:
    'first'
    'second'
    'large';
  }
`;

export const StyledContainer = styled(Container)`
  position: relative;
  z-index: 2;
`;

export const ShieldBackground = styled.div<{ backgroundImg: string }>`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: calc(100% - 249px);
  width: 100%;
  height: 100%;
  background-image: url(${props => props.backgroundImg});
  background-position: center;
  background-repeat: no-repeat;
  background-size: 100%;

  @media (min-width: 1829px) {
    background-position: left;
    background-size: cover;
  }

  @media (min-width: 2300px) {
    background-position: left;
    background-size: cover;
    max-width: calc(100% - 629px);
  }

  @media (max-width: ${breakPoints.desktop}) {
    background-position: bottom;
    max-width: 100%;
  }

  @media (max-width: ${breakPoints.sDesktop}) {
    background-position: -274px -100px;
    max-width: 100%;
    background-size: 1256px;
  }

  @media (max-width: ${breakPoints.tablet}) {
    background-position: -118px -54px;
    background-size: 880px;
  }

  @media (max-width: ${breakPoints.mobile}) {
    background-position: top right;
    background-size: 851px;
    top: -70px;
  }
`;

export const EnemyShipContainer = styled(Container)`
  position: absolute;
  z-index: 2;
  height: 680px;
  left: calc(50% - 678px);

  @media (max-width: ${breakPoints.desktop}) {
    height: 468px;
    left: calc(50% - 613px);
  }

  @media (max-width: ${breakPoints.sDesktop}) {
    height: 544px;
    left: calc(50% - 464.5px);
  }
`;

export const EnemyShipImage = styled.img.attrs({
    src: 'static/images/movix-new/enemy-ship.svg',
})`
  position: absolute;
  left: -73px;
  bottom: 0;
  z-index: 2;

  @media (max-width: ${breakPoints.desktop}) {
    width: 60px;
    height: 59px;
    left: 80px;
    top: 20px;
    bottom: -40px;
  }

  @media (max-width: ${breakPoints.sDesktop}) {
    width: 65px;
    height: 64px;
    left: 20px;
    bottom: 0;
  }

  @media (max-width: ${breakPoints.tablet}) {
    display: none;
  }
`;

export const TextBlock = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 583px;
  width: 100%;
  margin-bottom: 160px;
  margin-top: 319px;

  @media (max-width: ${breakPoints.desktop}) {
    max-width: 548px;
    margin-bottom: 141px;
    margin-top: 211px;
  }

  @media (max-width: ${breakPoints.sDesktop}) {
    max-width: 432px;
    margin-bottom: 137px;
    margin-top: 172px;
  }

  @media (max-width: ${breakPoints.tablet}) {
    max-width: 387px;
    margin-bottom: 160px;
    margin-top: 126px;
  }

  @media (max-width: ${breakPoints.mobile}) {
    max-width: 100%;
    margin-bottom: 27px;
    margin-top: 358px;
  }
`;

export const Title = styled.div`
  ${FONTS.H2}
  margin: 8px 0 12px 0;
  color: ${COLORS.TextWhite};

  @media (max-width: ${breakPoints.sDesktop}) {
     ${FONTS.H3}
  }
`;

export const Description = styled.div`
  ${FONTS.M}
  color: ${COLORS.TextWhite};
  white-space: pre-wrap;

  @media (max-width: ${breakPoints.sDesktop}) {
    ${FONTS.XS}
    max-width: 430px;
  }

  @media (max-width: ${breakPoints.tablet}) {
    white-space: normal;
  }
`;

export const YellowText = styled.div`
  ${FONTS.M}
  color: ${COLORS.TextWhite};

  @media (max-width: ${breakPoints.sDesktop}) {
    ${FONTS.XS}
  }
`;
